import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';

import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, LoaderComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { MbsPopupType } from 'mbs-ui-kit/utils/enums/mbs-popup-enum';
import Computer from 'mbs-ui-shared@models/Computer';
import { ConnectSettingsScope } from 'mbs-ui-shared@models/connect/connect-settings.models';
import { SidepanelRouteType } from 'mbs-ui-shared@models/sidepanel';
import { ConnectService } from 'mbs-ui-shared@services/connect.service';

@UntilDestroy()
@Component({
  selector: 'mbs-remote-connection-allow-modal-component',
  templateUrl: './remote-connection-allow-modal.component.html',
  styleUrls: ['./remote-connection-allow-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    LoaderComponent,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionAllowModalComponent implements OnInit {
  private connectService = inject(ConnectService);
  private router = inject(Router);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly mbsPopupType = MbsPopupType;
  public loading = true;
  public errorMessage = null;
  public hasPerComputerSettings = false;

  ngOnInit() {
    this.getErrorMessage();
  }

  getErrorMessage(): void {
    this.connectService.getSettings(ConnectSettingsScope.Computer, this.baseModal.data.computer.hid).subscribe((settings) => {
      this.loading = false;
      if (settings) {
        this.hasPerComputerSettings = true;
      } else {
        this.errorMessage = this.connectService.getRemoteAccessNotAllowedError(this.baseModal.data.computer);
      }
    });
  }

  onPerComputerButtonClick() {
    this.router.navigate([location.pathname, this.baseModal.data.computer.hid], {
      queryParams: { sidepanel: SidepanelRouteType.ConnectSettings }
    });
    this.baseModal.close();
  }

  getComputerName(): string {
    return Computer.getComputerName(this.baseModal.data.computer);
  }
}
